














import { computed, defineComponent, useRoute, useRouter, watch } from '@nuxtjs/composition-api';
import useResponsive from '@shared/composables/useResponsive';
import useToggleState from '@shared/composables/useToggleState';
import useUiState from '@shared/composables/useUiState';
import { UCAppHeaderItem } from '@shared/ui';
import { userGetters, useUser } from '@unified-commerce/gpc-vue-storefront-shopify';

import { Dropdown } from '~/components/AppHeader/constants';
import DropdownAccount from '~/components/AppHeader/DropdownAccount.vue';

export default defineComponent({
  name: 'HeaderAccount',
  components: { DropdownAccount, UCAppHeaderItem },
  setup() {
    const {
      state: dropdownOpen,
      setValue: setDropdownOpen,
      toggle: toggleDropdown,
    } = useToggleState(Dropdown.Account);
    const router = useRouter();
    const route = useRoute();
    const { user } = useUser();
    const { isMobile } = useResponsive();
    const { showAccountModal } = useUiState();

    const accountText = computed(() => {
      const firstName = userGetters.getFirstName(user.value);
      return isMobile.value && firstName.length > 6 ? 'Account' : `Hi ${firstName}`;
    });
    const isAuthenticated = computed(() => !!user.value?.token);

    const accountButtonClicked = () => {
      if (isMobile.value) {
        router.push('/account');
        setDropdownOpen(false);
      }

      if (isAuthenticated.value) {
        if (!isMobile.value) toggleDropdown();
      } else {
        showAccountModal();
      }
    };

    const closeDropdown = () => setDropdownOpen(false);

    watch(route, () => {
      closeDropdown();
    });

    watch(isMobile, (val) => {
      if (val) closeDropdown();
    });

    return {
      dropdownOpen,
      accountText,
      isAuthenticated,
      accountButtonClicked,
      closeDropdown,
    };
  },
});
